// extracted by mini-css-extract-plugin
module.exports = {"vLinkColor":"#1c7cf4","vBlue1":"#23527c","link":"RegAgreement_link__2pPV5"};